module.exports = "/_next/static/files/b4cc6bb699c41fd2278a37275236e9c4.png";